<template>
  <nav class="nav" :class="{ 'nav-mobile': mobileMode }">
    <section class="top">
      <ul v-if="mobileMode">
        <close-button class="close" @click="$emit('close')"></close-button>
        <li class="mobile-home" @click="goHome">
          <img
            v-if="!customLogo"
            id="rijnja-logo"
            class="logo"
            src="../../images/logo/rijnja_prints_voor_professionals_logo.svg"
          />
          <img v-else class="custom-logo" id="custom-logo" :src="customLogo" />
        </li>

        <li class="menu-item-container">
          <router-link
            :to="{
              name: 'printStore'
            }"
            class="main-menu-item"
            :class="{ active: $route.name === 'printStore' }"
          >
            Signing
          </router-link>
        </li>
      </ul>
      <h2 class="cat-header">Categorieën</h2>

      <ul v-if="!defaultPrintStore && !hideRijnjaContent">
        <li class="menu-item-container">
          <button
            class="main-menu-item"
            @click="toggleSubMenu"
            :style="
              customStyle(printStoreColor, activeCategory || subCategoryActive)
            "
            :class="{
              open: visibleCats.length,
              active: activeCategory || subCategoryActive
            }"
          >
            {{ rootStore.theme.printStore.name }}
          </button>
        </li>
      </ul>

      <transition-group
        v-if="!defaultPrintStore"
        appear
        name="movein"
        tag="ul"
        :class="{ 'sub-menu': !hideRijnjaContent }"
      >
        <li
          v-for="(category, index) in visibleCats"
          :key="category.id"
          class="menu-item-container"
          :style="{ '--delay': index * 30 + 'ms' }"
        >
          <router-link
            :to="{
              name: 'printStoreCategory',
              params: { categoryId: category.id }
            }"
            class="main-menu-item"
            :class="{
              active: $route.params.categoryId === category.id,
              hidden: !category.active
            }"
            :style="
              customStyle(
                category.colour,
                $route.params.categoryId === category.id
              )
            "
          >
            {{ category.name }}
          </router-link>
        </li>
      </transition-group>
      <ul v-if="!hideRijnjaContent">
        <li
          v-for="category in defaultCategories"
          :key="category.id"
          class="menu-item-container"
        >
          <router-link
            :to="{
              name: 'printStoreCategory',
              params: { categoryId: category.id }
            }"
            class="main-menu-item"
            :class="{
              active: $route.params.categoryId === category.id,
              hidden: !category.active
            }"
            :style="
              buttonStyle(
                category.colour,
                $route.params.categoryId === category.id
              )
            "
          >
            {{ category.name }}
            <span v-if="category.newBadge" class="new-badge">NIEUW</span>
          </router-link>
        </li>
      </ul>
    </section>
  </nav>
</template>

<script>
import { deleteCategory as apiDeleteCategory } from '@/features/printstore/PrintStoreApi'
import PrintStoreMixin from './PrintStoreMixin'
import AdList from './dialogs/AdList.vue'
//import AuthorizationComponent from '../../components/AuthorizationComponent.vue'
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  //  components: { AuthorizationComponent },
  props: {
    mobileMode: {
      type: Boolean,
      default: false
    }
  },
  mixins: [PrintStoreMixin],
  data() {
    return {
      defaultCats: true,
      showSub: false
      //visibleCats: []
    }
  },
  mounted() {
    if (this.hideRijnjaContent || this.categories.length > 1) {
      this.showSub = true
    }
  },
  watch: {
    categories(cats) {
      if (cats.length > 1) {
        this.showSub = true
      }
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    activeCategory() {
      return (
        (this.categories.length === 1 &&
          this.$route.params.categoryId === this.categories[0].id) ||
        (this.categories.length !== 1 && this.$route.name === 'printStoreIntro')
      )
    },
    categories() {
      return this.setCatsList(this.printStoreStore.categories)
    },
    subCategoryActive() {
      return this.categories.some(
        (category) => category.id === this.$route.params.categoryId
      )
    },
    defaultCategories() {
      return this.setCatsList(this.printStoreStore.defaultCategories)
    },
    hasSharedItems() {
      return this.printStoreStore.hasShared
    },
    customLogo() {
      if (this.rootStore.theme.header.menuRight.customLogo) {
        return (
          '//images.rijnja.nl/images/logos/themes' +
          this.rootStore.theme.header.menuRight.customLogo
        )
      } else {
        return false
      }
    },
    defaultPrintStore() {
      return this.rootStore.theme.printStore.isDefault
    },
    visibleCats() {
      if (!this.showSub) {
        return []
      } else {
        return this.categories
      }
    }
  },
  methods: {
    setCatsList(cats) {
      let catsList = [...cats]

      catsList = catsList.filter((cat) => cat.active)

      for (let i = 0; i < catsList.length; i++) {
        if (catsList[i].listOnTop) {
          const toTop = catsList[i]
          catsList.splice(i, 1)
          catsList.unshift(toTop)
        }
      }

      return catsList
    },
    buttonStyle(color, active) {
      if (!this.defaultPrintStore) {
        return {}
      }
      let psColor = color || this.rootStore.theme.subColor

      if (active) {
        return {
          'background-color': psColor,
          color: 'white',
          'border-color': psColor
        }
      } else {
        return {
          color: psColor,
          'border-color': psColor
        }
      }
    },
    customStyle(color = '', active = false) {
      const psColor =
        color || this.printStoreColor || this.rootStore.theme.subColor

      if (active) {
        return {
          'background-color': psColor,
          color: 'white',
          'border-color': psColor
        }
      } else {
        return {
          color: psColor,
          'border-color': psColor
        }
      }
    },
    goHome() {
      this.$router.push({ name: 'home' })
      this.rootStore.setHome()
    },
    deleteCategory(id) {
      this.confirmationDialog(
        'Wilt u deze categorie met alle pakketten en collecties er in verwijderen?',
        'Verwijderen',
        async () => {
          await apiDeleteCategory(id)
          await this.printStoreStore.removeCategory(id)
          await this.$router.push({ name: 'printStore' })
        }
      )
    },
    showAdList() {
      this.$modal.show(
        AdList,
        {},
        {
          width: 340,
          height: 'auto',
          scrollable: true
        }
      )
    },
    toggleSubMenu() {
      if (this.categories.length === 1) {
        this.showSub = false
        this.$router.push({
          name: 'printStoreCategory',
          params: { categoryId: this.categories[0].id }
        })
      } else {
        //        this.showSub = !this.showSub
        if (this.categories.length && this.showSub) {
          this.$router.push({
            name: 'printStoreCategory',
            params: { categoryId: this.categories[0].id }
          })
        } else {
          this.$router.push({ name: 'printStoreIntro' })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../sass/base/_colors.scss' as *;

.mobile-home {
  width: 160px;
  margin-bottom: 10px;
}

.close {
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 10;
}

.logo {
  width: 160px;
  height: 35px;
  margin-bottom: 12px;
}

.custom-logo {
  margin-bottom: 12px;
  max-width: 160px;
  max-height: 35px;
}

.nav-mobile {
  background: white;
  box-shadow: rgba(0, 0, 0, 0.2) 20px 0 50px;
  left: 15px;
  padding: 20px;
  position: fixed;
  top: 15px;
  bottom: 15px;
  max-width: 350px;
  width: calc(100vw - 30px);
  z-index: 15;
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.cat-header {
  font-size: 19px;
  color: var(--sub-color);
  font-weight: 500;
  padding-bottom: 22px;
}

.main-menu-item {
  //height: 30px;
  display: inline-block;
  background-color: #fff;
  color: var(--sub-color);
  border-radius: 18px;
  padding: 0 15px;
  line-height: 30px;
  text-decoration: none;
  font-weight: 500;
  font-size: 12px;
  transition: all 0.25s;
  border: 2px solid var(--sub-color);
  position: relative;

  &.router-link-exact-active {
    color: white;
    background-color: $text-color;
  }

  &.active {
    color: white;
    background-color: var(--sub-color);

    &:hover {
      color: white;
      //cursor: default;
      box-shadow: none;
    }

    svg {
      fill: white !important;
    }
  }

  &.hidden {
    opacity: 0.5;
  }

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.2) 0 0 10px;
  }

  svg {
    display: inline-block;
    margin-right: 4px;
    fill: var(--sub-color);
    transition: transform 0.3s;
  }

  &.open svg {
    transform: rotate(90deg);
    transform-origin: center;
  }
}

.leave {
  font-weight: 500;
  color: var(--sub-color);
  padding-left: 15px;
}

.menu-item-container {
  //display: flex;
  align-items: center;
  margin-bottom: 25px;

  .kebab-btn {
    opacity: 0;
    transition: opacity 0.6s;

    span {
      background-color: var(--sub-color);
    }
  }

  &:hover {
    .kebab-btn {
      opacity: 1;
    }
  }

  .menu {
    padding-top: 5px;
    position: absolute;
    left: 3px;
  }
}

hr {
  border-top: 1px solid #979797;
  margin-bottom: 17px;
  margin-right: 27px;
}

.admin-menu {
  background-color: #f0f0f0;
  padding: 6px;
  line-height: 28px;
  border-radius: 15px;
  margin-top: auto;
  display: block;
  width: 130px;

  h2 {
    font-weight: 600;
    padding-left: 6px;
  }

  button {
    margin: 5px 0;
    display: block;
  }
}

.sub-menu {
  padding-left: 15px;
  overflow: hidden;
}

.movein-enter-active {
  animation: menu-in 0.35s both;
  animation-delay: var(--delay);
}

.new-badge {
  position: absolute;
  display: block;
  top: -10px;
  background: red;
  color: white;
  font-size: 9px;
  font-weight: 600;
  padding: 4px 8px;
  line-height: 9px;
  border-radius: 10px;
  right: -5px;
}
</style>
